export default "__VITE_ASSET__Barc4j23__"